import * as Sentry from "@sentry/react";
import { browserTracingIntegration } from "@sentry/react";
import Cookie from "js-cookie";
import { getChannel } from "./tools";
import { resolveUid } from "./host-login-state";

const env = {
  network: null as null | "test" | "preview" | "production",
};
switch (window.location.hostname) {
  case "static.test.xiaopeng.local":
    env.network = "test";
    break;
  case "static.deploy-test.xiaopeng.com":
    env.network = "preview";
    break;
  case "static.xiaopeng.com":
    env.network = "production";
    break;
  default:
    env.network = null;
    break;
}

let environment = "dev";
if (env.network === "test") {
  environment = "test";
} else if (env.network === "preview") {
  environment = "preview";
} else if (env.network === "production") {
  environment = "production";
}

// appName 与 DSN 的映射关系
const DSN_MAP: Record<string, string> = {
  "charge-vip":
    "https://6830c29b581d495fb41291e80040fd3f@front-monitor.xiaopeng.com/198",
};

const DEFAULT_DSN =
  "https://e46ce1ed61fe446e83ac12a456b56ad3@front-monitor.xiaopeng.com/178";

const buildTime = __BUILD_TIME__;
const buildVersion = __BUILD_VERSION__;

const SentryRun = (appName: string) => {
  const sentryDsn = DSN_MAP[appName] || DEFAULT_DSN;

  if (!sentryDsn) {
    console.warn("Sentry DSN is not configured");
    return;
  }

  Sentry.init({
    dsn: sentryDsn,
    integrations: [browserTracingIntegration()],
    environment: process.env.NODE_ENV === "development" ? "dev" : environment,
    release: `xp-charge-par-web@${buildVersion}`,
    debug: environment === "dev",
    tracesSampleRate: 0.2,
    sampleRate: 0.5,
  });

  // 宿主声明的身份优先，避免退登 / 切号后把问题上报挂到上一个用户名下
  const userId =
    resolveUid(
      () =>
        sessionStorage.getItem("sessionUid") || Cookie.get("wasxuid_r") || "",
    ) || "-1";
  Sentry.setTag("channel", getChannel());
  Sentry.setTag("appName", appName);
  Sentry.setTag("buildTime", buildTime);
  Sentry.setTag("buildVersionTag", buildVersion);
  Sentry.setUser({
    id: userId || "-1",
  });
};

export const sentrySetUser = (user: { id: string; [key: string]: unknown }) => {
  Sentry.setUser(user);
};

export default SentryRun;
